'use client'

import { openLogin } from '@/components/auth/open-auth'
import { useIsLoggedIn } from '@/hooks/react-query/user/use-user'
import { useEffect } from 'react'
import { BannerClub } from './_components/banner-club'
import { CoolClubBenefitsSection } from './_components/benefits-section'
import { CoolClubMoments } from './_components/coolclub-moments'
import { CoolClubReviews } from './_components/coolclub-reviews'
import { CoolClubFaq } from './_components/faq'
import { MembershipTiers } from './_components/membership-tiers'
import { ShareFriend } from './_components/share-friend'

export default function CoolClubPage() {
  const isLoggedIn = useIsLoggedIn()

  useEffect(() => {
    if (isLoggedIn === false) {
      setTimeout(() => {
        openLogin()
      }, 300) // delay để popup mount đúng lúc
    }
  }, [isLoggedIn])

  return (
    <div className='space-y-15 lg:space-y-20 lg:pt-20'>
      <BannerClub isLogin={isLoggedIn} />
      <CoolClubBenefitsSection />
      {/* <CoolClubMap /> */}
      <MembershipTiers />
      <CoolClubMoments />
      <CoolClubReviews />
      <ShareFriend />
      <CoolClubFaq />
    </div>
  )
}
